/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Cursor represents a paginating cursor. */
  Cursor: { input: any; output: any; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AddRatingInternalInput = {
  rating: Scalars['Float']['input'];
  submissionID: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type Brand = {
  __typename?: 'Brand';
  logoURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export type By = {
  by: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export enum Comment_Sort {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  RatingAsc = 'RATING_ASC',
  RatingDesc = 'RATING_DESC',
  RepliesAsc = 'REPLIES_ASC',
  RepliesDesc = 'REPLIES_DESC'
}

export enum Comment_Status {
  Approved = 'APPROVED',
  None = 'NONE',
  Premod = 'PREMOD',
  Rejected = 'REJECTED',
  SystemWithheld = 'SYSTEM_WITHHELD'
}

export type CandidateSummary = {
  __typename?: 'CandidateSummary';
  ages?: Maybe<Scalars['JSON']['output']>;
  chests?: Maybe<Scalars['JSON']['output']>;
  cities?: Maybe<Scalars['JSON']['output']>;
  eyeColors?: Maybe<Scalars['JSON']['output']>;
  heights?: Maybe<Scalars['JSON']['output']>;
  hips?: Maybe<Scalars['JSON']['output']>;
  isRepresented?: Maybe<Scalars['JSON']['output']>;
  nationalities?: Maybe<Scalars['JSON']['output']>;
  openCallId?: Maybe<Scalars['JSON']['output']>;
  stageId?: Maybe<Scalars['JSON']['output']>;
  waists?: Maybe<Scalars['JSON']['output']>;
};

export type CommentEdge = {
  __typename?: 'CommentEdge';
  cursor: Scalars['Cursor']['output'];
  node: CoralComment;
};

export type CommentModerationAction = {
  __typename?: 'CommentModerationAction';
  id: Scalars['ID']['output'];
};

export type CommentModerationActionConnection = {
  __typename?: 'CommentModerationActionConnection';
  edges: Array<CommentModerationActionEdge>;
  nodes: Array<CommentModerationAction>;
  pageInfo: PageInfo;
};

export type CommentModerationActionEdge = {
  __typename?: 'CommentModerationActionEdge';
  cursor: Scalars['Cursor']['output'];
  node: CommentModerationAction;
};

/**
 *
 *   It's a partial representation of the coral comment response. The main difference is that we are saving in the storyID the submissionID value (OpenCall candidate id).
 *
 *   For more information, see: [https://coral-stag.condenastdigital.com/graphiql](https://coral-stag.condenastdigital.com/graphiql)
 *
 *
 */
export type CommentResponse = {
  __typename?: 'CommentResponse';
  authorID: Scalars['String']['output'];
  childCount: Scalars['Int']['output'];
  childIDs: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  meta?: Maybe<Meta>;
  parentID?: Maybe<Scalars['String']['output']>;
  parentRevisionID?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingID?: Maybe<Scalars['String']['output']>;
  replyTotal?: Maybe<Scalars['Int']['output']>;
  revisions: Array<CommentRevisionResponse>;
  siteID: Scalars['String']['output'];
  status?: Maybe<Comment_Status>;
  storyID: Scalars['String']['output'];
  tenantID: Scalars['String']['output'];
};

export type CommentRevision = {
  __typename?: 'CommentRevision';
  id: Scalars['ID']['output'];
};

export type CommentRevisionResponse = {
  __typename?: 'CommentRevisionResponse';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Meta>;
};

export type CommentsConnection = {
  __typename?: 'CommentsConnection';
  edges: Array<CommentEdge>;
  nodes: Array<CoralComment>;
  pageInfo: PageInfo;
};

/** Contact Info. Used by front end to display contact info also to export from the Talent Tracker Tool. */
export type ContactInfo = {
  __typename?: 'ContactInfo';
  averageScore?: Maybe<Scalars['Float']['output']>;
  candidateId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pronouns: Scalars['String']['output'];
  stageId: Scalars['String']['output'];
};

export type CoralComment = {
  __typename?: 'CoralComment';
  author?: Maybe<CoralUser>;
  body: Scalars['String']['output'];
  canModerate: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  depth: Scalars['Int']['output'];
  editing: EditInfo;
  id: Scalars['ID']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CoralComment>;
  parentCount: Scalars['Int']['output'];
  parents: CommentsConnection;
  permalink: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  ratingID?: Maybe<Scalars['String']['output']>;
  replies: CommentsConnection;
  replyCount: Scalars['Int']['output'];
  revision?: Maybe<CommentRevision>;
  revisionHistory: Array<CommentRevision>;
  rootParent?: Maybe<CoralComment>;
  seen: Scalars['Boolean']['output'];
  site: Site;
  status: Comment_Status;
  statusHistory: CommentModerationActionConnection;
  story: Story;
  totalReplyCount: Scalars['Int']['output'];
};

export type CoralRating = {
  __typename?: 'CoralRating';
  authorID?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  siteID?: Maybe<Scalars['String']['output']>;
  storyID?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updateAt?: Maybe<Scalars['Date']['output']>;
  userID?: Maybe<Scalars['String']['output']>;
};

export type CoralUser = {
  __typename?: 'CoralUser';
  amgUuid?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  badges?: Maybe<Array<Scalars['String']['output']>>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duplicateEmail?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  ignoreable: Scalars['Boolean']['output'];
  lastDownloadedAt?: Maybe<Scalars['Date']['output']>;
  scheduledDeletionDate?: Maybe<Scalars['Date']['output']>;
  siteID?: Maybe<Scalars['String']['output']>;
  ssoURL?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CreateCommentInternalInput = {
  body: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  submissionID: Scalars['String']['input'];
};

/**
 * CreateCommentPayload contains the created Comment after the createComment mutation.
 *
 *   For more information, see: [https://coral-stag.condenastdigital.com/graphiql](https://coral-stag.condenastdigital.com/graphiql)
 *
 */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  clientMutationId: Scalars['String']['output'];
  edge: CommentEdge;
  error?: Maybe<Scalars['String']['output']>;
};

/** It's an abstraction of the real Coral comment object `CreateCommentReplyInput`. It's replaced internally on the mutation. */
export type CreateCommentReplyInputInternal = {
  /** The body of the comment. Note: comments like `test`, `asdasd`, `Lorem ipsum`, etc. are considered spam and will not appear on the list of comments. */
  body: Scalars['String']['input'];
  /** The parent comment ID. */
  parentID: Scalars['ID']['input'];
  /** The parent comment revision ID. */
  parentRevisionID: Scalars['ID']['input'];
  /** The OpenCall candidate ID. */
  submissionID: Scalars['ID']['input'];
};

/** Information about the user who created the comment. */
export type CreatedBy = {
  __typename?: 'CreatedBy';
  /** The ID of the user in the Coral Comment service. For more information, see: [https://coral-stag.condenastdigital.com/graphiql](https://coral-stag.condenastdigital.com/graphiql) */
  coralUserID: Scalars['String']['output'];
  /** The email of the user that created the comment. */
  email: Scalars['String']['output'];
  /** The ID of the user that created the comment. It's the Okta ID of the user. */
  id: Scalars['String']['output'];
  /** The name of the user. */
  name?: Maybe<Scalars['String']['output']>;
  /** The username of the user. It's the Okta username. */
  username?: Maybe<Scalars['String']['output']>;
};

export type EditCommentInputInternal = {
  body: Scalars['String']['input'];
  commentID: Scalars['ID']['input'];
};

/**
 * EditCommentPayload contains the edited Comment after the editComment mutation.
 *
 *   For more information, see: [https://coral-stag.condenastdigital.com/graphiql](https://coral-stag.condenastdigital.com/graphiql)
 *
 */
export type EditCommentPayload = {
  __typename?: 'EditCommentPayload';
  clientMutationId: Scalars['String']['output'];
  comment: CoralComment;
};

export type EditInfo = {
  __typename?: 'EditInfo';
  editableUntil?: Maybe<Scalars['Date']['output']>;
  edited: Scalars['Boolean']['output'];
};

/** Export to Copilot Response. It's used by application to integrate with the Copilot */
export type ExportToCopilotResponse = {
  __typename?: 'ExportToCopilotResponse';
  visualStoryURL: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  message?: Maybe<Scalars['String']['output']>;
};

/** Extra information about the comment. Currently, used to save the user that created the comment. */
export type Meta = {
  __typename?: 'Meta';
  createdBy?: Maybe<CreatedBy>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** addRatings will create a new rating in a specific submission. It'll return a `400 (bad request)` if the user already rate an submission. */
  addRatings: Message;
  bulkChangeStage: SubmissionsResponse;
  createComment?: Maybe<CreateCommentPayload>;
  createCommentReply: CommentResponse;
  createStage: OpenCallStage;
  editComment: EditCommentPayload;
  renameStage: OpenCallStage;
};


export type MutationAddRatingsArgs = {
  input: AddRatingInternalInput;
};


export type MutationBulkChangeStageArgs = {
  candidateIds?: Array<Scalars['String']['input']>;
  stageId?: Scalars['String']['input'];
  userId?: Scalars['String']['input'];
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInternalInput;
};


export type MutationCreateCommentReplyArgs = {
  input: CreateCommentReplyInputInternal;
};


export type MutationCreateStageArgs = {
  openCallId?: Scalars['String']['input'];
};


export type MutationEditCommentArgs = {
  input: EditCommentInputInternal;
};


export type MutationRenameStageArgs = {
  newName: Scalars['String']['input'];
  openCallId: Scalars['String']['input'];
  stageId: Scalars['String']['input'];
};

/** Represents an Open Call on Talent Tracker Tool */
export type OpenCall = {
  __typename?: 'OpenCall';
  brand: Brand;
  closedAt: Scalars['Date']['output'];
  createdAt: Scalars['Date']['output'];
  defaultStageId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAmericanStyleOpenCall: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stages: Array<OpenCallStage>;
  status: OpenCallStatus;
  totalApplicants?: Maybe<Scalars['Int']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
};

export type OpenCallInfoForCopilotExport = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/**
 *
 *   This represents an Open Call Stage.
 *
 *   It can be: `Applicants`, `Jury`, `Finalists`, `Dismissed`, or a custom stage created by the super user.
 *
 */
export type OpenCallStage = {
  __typename?: 'OpenCallStage';
  count: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  openCallId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  viewPermissions: Array<ViewPermissions>;
};

/**
 * This represents the status of an Open Call.
 *  When CLOSED, the user can still access the application, but in read-only mode.
 */
export enum OpenCallStatus {
  Closed = 'CLOSED',
  Live = 'LIVE'
}

/** A paginated list of Open Calls */
export type OpenCallsResponse = {
  __typename?: 'OpenCallsResponse';
  items: Array<OpenCall>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Specifies the last node's cursor for forwards pagination. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Included for legacy Relay reasons. Always set to null. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};

export type Photo = {
  __typename?: 'Photo';
  photo: PhotoAsset;
};

export type PhotoAsset = {
  __typename?: 'PhotoAsset';
  assetId?: Maybe<Scalars['String']['output']>;
  assetMetaData: Scalars['JSON']['output'];
  assetType: Scalars['String']['output'];
  encodedURI?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  address: Address;
  contactEmail: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  dob: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  pronouns: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  contactExport: Array<ContactInfo>;
  coralcomment?: Maybe<CommentResponse>;
  coralcomments: Array<CommentResponse>;
  /** Returns a rating by its ID. */
  coralrating?: Maybe<RatingResponse>;
  /** Return all ratings for a specific submission. */
  coralratings: Array<RatingResponse>;
  exportFinalistsToCopilot: ExportToCopilotResponse;
  openCall?: Maybe<OpenCall>;
  openCalls: OpenCallsResponse;
  stageId: OpenCallStage;
  stages: Array<OpenCallStage>;
  /** A custom implementation of the Coral Comment `storyRating` query. It'll get all the stories related to a submission. */
  storyRating?: Maybe<RatingAverageResponse>;
  submissions: SubmissionsResponse;
};


export type QueryContactExportArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCoralcommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoralcommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Comment_Sort>;
  query?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<SectionFilter>;
  showPrimaryComments?: InputMaybe<Scalars['Boolean']['input']>;
  siteID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Comment_Status>;
  submissionID?: InputMaybe<Scalars['ID']['input']>;
  tag?: InputMaybe<Tag>;
};


export type QueryCoralratingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoralratingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  siteID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Story_Status>;
  submissionID?: InputMaybe<Scalars['ID']['input']>;
  tenantID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExportFinalistsToCopilotArgs = {
  ids: Array<Scalars['String']['input']>;
  openCall: OpenCallInfoForCopilotExport;
};


export type QueryOpenCallArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpenCallsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryStageIdArgs = {
  openCallId?: Scalars['String']['input'];
  stageId?: Scalars['String']['input'];
};


export type QueryStagesArgs = {
  openCallId?: Scalars['String']['input'];
};


export type QueryStoryRatingArgs = {
  ratingScale?: InputMaybe<Scalars['Int']['input']>;
  submissionID?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubmissionsArgs = {
  params?: InputMaybe<SubmissionQueryParams>;
};

/**
 * Rating Average Response is the same as the Coral Comment service, with an additional property to facilitate the front-end integration.
 *
 *   For more information, see [https://coral-stag.condenastdigital.com/graphiql](https://coral-stag.condenastdigital.com/graphiql).
 *
 */
export type RatingAverageResponse = {
  __typename?: 'RatingAverageResponse';
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  storyID: Scalars['String']['output'];
};

export type RatingEdge = {
  __typename?: 'RatingEdge';
  cursor: Scalars['Cursor']['output'];
  node: CoralRating;
};

/**
 * Rating Response is an adaptation from `CoralRating` to better support tje Talent Tracker Tool application.
 *
 *   For more information, see [https://coral-stag.condenastdigital.com/graphiql](https://coral-stag.condenastdigital.com/graphiql).
 *
 */
export type RatingResponse = {
  __typename?: 'RatingResponse';
  authorID: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  rating: Scalars['Float']['output'];
  ratingScale: Scalars['Int']['output'];
  siteID: Scalars['String']['output'];
  status: Scalars['String']['output'];
  storyID: Scalars['String']['output'];
  tenantID: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum Story_Status {
  Closed = 'Closed',
  Open = 'Open'
}

export type SectionFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Site = {
  __typename?: 'Site';
  allowedOrigins: Array<Scalars['String']['output']>;
  canModerate: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ratingScale: Scalars['Int']['output'];
};

export type Story = {
  __typename?: 'Story';
  id: Scalars['ID']['output'];
};

export type Submission = {
  __typename?: 'Submission';
  _id: Scalars['String']['output'];
  amountOfRatings?: Maybe<Scalars['Int']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  data: SubmissionDataDetails;
  profile: Profile;
  rating?: Maybe<RatingResponse>;
  ratings?: Maybe<Array<RatingResponse>>;
  updatedAt: Scalars['String']['output'];
};

export type SubmissionDataDetails = {
  __typename?: 'SubmissionDataDetails';
  formDetails?: Maybe<Scalars['JSON']['output']>;
  openCallId: Scalars['String']['output'];
  personalAttributes?: Maybe<SubmissionPersonalAttributes>;
  personalDetails?: Maybe<SubmissionPersonalDetails>;
  portfolio: SubmissionPortfolio;
  stageId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userProfileId: Scalars['String']['output'];
};

export type SubmissionFilters = {
  ages?: InputMaybe<Array<Scalars['String']['input']>>;
  chests?: InputMaybe<Array<Scalars['String']['input']>>;
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  eyeColors?: InputMaybe<Array<Scalars['String']['input']>>;
  heights?: InputMaybe<Array<Scalars['String']['input']>>;
  hips?: InputMaybe<Array<Scalars['String']['input']>>;
  isRepresented?: InputMaybe<Scalars['Boolean']['input']>;
  nationalities?: InputMaybe<Array<Scalars['String']['input']>>;
  openCallId: Scalars['String']['input'];
  stageId: Scalars['String']['input'];
  waists?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubmissionPersonalAttributes = {
  __typename?: 'SubmissionPersonalAttributes';
  chest: Scalars['String']['output'];
  eyeColor: Scalars['String']['output'];
  hairColor: Scalars['String']['output'];
  height: Scalars['String']['output'];
  hips: Scalars['String']['output'];
  waist: Scalars['String']['output'];
};

export type SubmissionPersonalDetails = {
  __typename?: 'SubmissionPersonalDetails';
  agencyName?: Maybe<Scalars['String']['output']>;
  experienceBrief: Scalars['String']['output'];
  instaHandle?: Maybe<Scalars['String']['output']>;
  referredByModelAgency: Scalars['Boolean']['output'];
  tiktokHandle?: Maybe<Scalars['String']['output']>;
};

export type SubmissionPortfolio = {
  __typename?: 'SubmissionPortfolio';
  photos: Array<Photo>;
  videos: Array<Video>;
};

/** A list of params for submissions. */
export type SubmissionQueryParams = {
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters: SubmissionFilters;
  pagination?: InputMaybe<Pagination>;
  sort: SubmissionSort;
};

export type SubmissionSort = {
  amountOfRatings?: InputMaybe<By>;
  averageRating?: InputMaybe<By>;
  createdAt?: InputMaybe<By>;
};

/** Submissions response. A list of submissions from a Open Call. */
export type SubmissionsResponse = {
  __typename?: 'SubmissionsResponse';
  _ids: Array<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  data: Array<Submission>;
  summary: CandidateSummary;
};

export enum Tag {
  Admin = 'ADMIN',
  Expert = 'EXPERT',
  Featured = 'FEATURED',
  Member = 'MEMBER',
  Moderator = 'MODERATOR',
  Question = 'QUESTION',
  Review = 'REVIEW',
  Staff = 'STAFF',
  Tip = 'TIP',
  Unanswered = 'UNANSWERED'
}

export type Video = {
  __typename?: 'Video';
  video: VideoAsset;
};

export type VideoAsset = {
  __typename?: 'VideoAsset';
  assetId?: Maybe<Scalars['String']['output']>;
  assetMetaData: Scalars['JSON']['output'];
  assetType: Scalars['String']['output'];
  assets?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** This represents the user permission related to the current stage. The information about this object comes from the Permify integration. */
export type ViewPermissions = {
  __typename?: 'ViewPermissions';
  name: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInternalInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment?: { __typename?: 'CreateCommentPayload', edge: { __typename?: 'CommentEdge', node: { __typename?: 'CoralComment', id: string, body: string, createdAt: any, replyCount: number, replies: { __typename?: 'CommentsConnection', edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'CoralComment', id: string, body: string, createdAt: any, replyCount: number } }> } } } } | null };

export type GetCommentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCommentQuery = { __typename?: 'Query', coralcomment?: { __typename?: 'CommentResponse', revisions: Array<{ __typename?: 'CommentRevisionResponse', id: string, body: string, isAnonymous?: boolean | null, meta?: { __typename?: 'Meta', createdBy?: { __typename?: 'CreatedBy', id: string, name?: string | null, username?: string | null, email: string } | null } | null }> } | null };

export type GetCommentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  submissionID?: InputMaybe<Scalars['ID']['input']>;
  siteID?: InputMaybe<Scalars['ID']['input']>;
  showPrimaryComments?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Comment_Status>;
  section?: InputMaybe<SectionFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Comment_Sort>;
}>;


export type GetCommentsQuery = { __typename?: 'Query', coralcomments: Array<{ __typename?: 'CommentResponse', id: string, createdAt: any, parentID?: string | null, parentRevisionID?: string | null, status?: Comment_Status | null, rating?: number | null, childCount: number, revisions: Array<{ __typename?: 'CommentRevisionResponse', id: string, body: string, isAnonymous?: boolean | null, createdAt: any, meta?: { __typename?: 'Meta', createdBy?: { __typename?: 'CreatedBy', name?: string | null, username?: string | null, id: string, email: string } | null } | null }> }> };

export type EditCommentMutationVariables = Exact<{
  input: EditCommentInputInternal;
}>;


export type EditCommentMutation = { __typename?: 'Mutation', editComment: { __typename?: 'EditCommentPayload', comment: { __typename?: 'CoralComment', id: string, body: string, createdAt: any, replyCount: number, parent?: { __typename?: 'CoralComment', id: string } | null, replies: { __typename?: 'CommentsConnection', edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'CoralComment', id: string, body: string, createdAt: any, replyCount: number } }> } } } };

export type ReplyCommentMutationVariables = Exact<{
  input: CreateCommentReplyInputInternal;
}>;


export type ReplyCommentMutation = { __typename?: 'Mutation', createCommentReply: { __typename?: 'CommentResponse', id: string, createdAt: any, parentID?: string | null, parentRevisionID?: string | null, childCount: number, revisions: Array<{ __typename?: 'CommentRevisionResponse', id: string, body: string, isAnonymous?: boolean | null, createdAt: any, meta?: { __typename?: 'Meta', createdBy?: { __typename?: 'CreatedBy', name?: string | null, username?: string | null, id: string, email: string } | null } | null }> } };

export type OpenCallsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type OpenCallsQuery = { __typename?: 'Query', openCalls: { __typename?: 'OpenCallsResponse', totalCount: number, page: number, limit: number, items: Array<{ __typename?: 'OpenCall', id: string, name: string, isAmericanStyleOpenCall: boolean, typeId?: string | null, status: OpenCallStatus, totalApplicants?: number | null, defaultStageId?: string | null, createdAt: any, closedAt: any, brand: { __typename?: 'Brand', organizationId: string, logoURL: string, name: string }, stages: Array<{ __typename?: 'OpenCallStage', id: string, isDefault?: boolean | null }> }> } };

export type OpenCallQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpenCallQuery = { __typename?: 'Query', openCall?: { __typename?: 'OpenCall', id: string, name: string, isAmericanStyleOpenCall: boolean, typeId?: string | null, status: OpenCallStatus, totalApplicants?: number | null, defaultStageId?: string | null, createdAt: any, closedAt: any, brand: { __typename?: 'Brand', organizationId: string, logoURL: string, name: string }, stages: Array<{ __typename?: 'OpenCallStage', id: string, isDefault?: boolean | null }> } | null };

export type CreateRatingMutationVariables = Exact<{
  input: AddRatingInternalInput;
}>;


export type CreateRatingMutation = { __typename?: 'Mutation', addRatings: { __typename?: 'Message', message?: string | null } };

export type CandidateRatingAverageQueryVariables = Exact<{
  submissionID: Scalars['String']['input'];
}>;


export type CandidateRatingAverageQuery = { __typename?: 'Query', storyRating?: { __typename?: 'RatingAverageResponse', average: number, count: number, storyID: string } | null };

export type GetRatingsQueryVariables = Exact<{
  submissionID: Scalars['ID']['input'];
}>;


export type GetRatingsQuery = { __typename?: 'Query', coralratings: Array<{ __typename?: 'RatingResponse', id: string, rating: number, status: string, authorID: string, storyID: string, createdAt: any }> };

export type OpenCallStagesQueryVariables = Exact<{
  openCallId: Scalars['String']['input'];
}>;


export type OpenCallStagesQuery = { __typename?: 'Query', stages: Array<{ __typename?: 'OpenCallStage', id: string, name: string, count: number, isDefault?: boolean | null, viewPermissions: Array<{ __typename?: 'ViewPermissions', name: string, value: boolean }> }> };

export type CreateStageMutationVariables = Exact<{
  openCallId: Scalars['String']['input'];
}>;


export type CreateStageMutation = { __typename?: 'Mutation', createStage: { __typename?: 'OpenCallStage', id: string, name: string, count: number, isDefault?: boolean | null, viewPermissions: Array<{ __typename?: 'ViewPermissions', name: string, value: boolean }> } };

export type RenameStageMutationVariables = Exact<{
  openCallId: Scalars['String']['input'];
  stageId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type RenameStageMutation = { __typename?: 'Mutation', renameStage: { __typename?: 'OpenCallStage', id: string, name: string, count: number, isDefault?: boolean | null, viewPermissions: Array<{ __typename?: 'ViewPermissions', name: string, value: boolean }> } };

export type SubmissionsQueryVariables = Exact<{
  params?: InputMaybe<SubmissionQueryParams>;
}>;


export type SubmissionsQuery = { __typename?: 'Query', submissions: { __typename?: 'SubmissionsResponse', count: number, _ids: Array<string>, data: Array<{ __typename?: 'Submission', createdAt: string, _id: string, updatedAt: string, averageRating?: number | null, amountOfRatings?: number | null, data: { __typename?: 'SubmissionDataDetails', formDetails?: any | null, openCallId: string, stageId: string, personalDetails?: { __typename?: 'SubmissionPersonalDetails', experienceBrief: string, referredByModelAgency: boolean, agencyName?: string | null, instaHandle?: string | null, tiktokHandle?: string | null } | null, personalAttributes?: { __typename?: 'SubmissionPersonalAttributes', height: string, chest: string, waist: string, hips: string, eyeColor: string } | null, portfolio: { __typename?: 'SubmissionPortfolio', photos: Array<{ __typename?: 'Photo', photo: { __typename?: 'PhotoAsset', assetId?: string | null, assetType: string, assetMetaData: any, thumbnailUrl?: string | null } }>, videos: Array<{ __typename?: 'Video', video: { __typename?: 'VideoAsset', status?: string | null, assetId?: string | null, assetType: string, assetMetaData: any, assets?: any | null } }> } }, profile: { __typename?: 'Profile', nationality?: string | null, firstName: string, lastName: string, pronouns: Array<string>, contactEmail: string, dob: string, status: string, address: { __typename?: 'Address', city: string, country: string } }, rating?: { __typename?: 'RatingResponse', id: string, rating: number, status: string, authorID: string, createdAt: any } | null, ratings?: Array<{ __typename?: 'RatingResponse', id: string, rating: number, status: string, authorID: string, createdAt: any }> | null }>, summary: { __typename?: 'CandidateSummary', isRepresented?: any | null, nationalities?: any | null, cities?: any | null, ages?: any | null, heights?: any | null, eyeColors?: any | null, hips?: any | null, chests?: any | null, waists?: any | null } } };

export type BulkChangeStageMutationVariables = Exact<{
  stageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  candidateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkChangeStageMutation = { __typename?: 'Mutation', bulkChangeStage: { __typename?: 'SubmissionsResponse', count: number } };

export type ContactExportQueryVariables = Exact<{
  candidateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ContactExportQuery = { __typename?: 'Query', contactExport: Array<{ __typename?: 'ContactInfo', candidateId: string, averageScore?: number | null, stageId: string, email: string, firstName: string, lastName: string, pronouns: string }> };

export type ExportFinalistsToCopilotQueryVariables = Exact<{
  candidateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  openCall: OpenCallInfoForCopilotExport;
}>;


export type ExportFinalistsToCopilotQuery = { __typename?: 'Query', exportFinalistsToCopilot: { __typename?: 'ExportToCopilotResponse', visualStoryURL: string } };


export const CreateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommentInternalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"replyCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"replyCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateCommentMutation, CreateCommentMutationVariables>;
export const GetCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coralcomment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCommentQuery, GetCommentQueryVariables>;
export const GetCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showPrimaryComments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"COMMENT_STATUS"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"COMMENT_SORT"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coralcomments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"submissionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionID"}}},{"kind":"Argument","name":{"kind":"Name","value":"siteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteID"}}},{"kind":"Argument","name":{"kind":"Name","value":"showPrimaryComments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showPrimaryComments"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentID"}},{"kind":"Field","name":{"kind":"Name","value":"parentRevisionID"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"revisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childCount"}}]}}]}}]} as unknown as DocumentNode<GetCommentsQuery, GetCommentsQueryVariables>;
export const EditCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditCommentInputInternal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"replyCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"replyCount"}}]}}]}}]}}]} as unknown as DocumentNode<EditCommentMutation, EditCommentMutationVariables>;
export const ReplyCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplyComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommentReplyInputInternal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCommentReply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"parentID"}},{"kind":"Field","name":{"kind":"Name","value":"parentRevisionID"}},{"kind":"Field","name":{"kind":"Name","value":"revisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"isAnonymous"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childCount"}}]}}]}}]} as unknown as DocumentNode<ReplyCommentMutation, ReplyCommentMutationVariables>;
export const OpenCallsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OpenCalls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openCalls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAmericanStyleOpenCall"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalApplicants"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStageId"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"logoURL"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]} as unknown as DocumentNode<OpenCallsQuery, OpenCallsQueryVariables>;
export const OpenCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OpenCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openCall"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAmericanStyleOpenCall"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalApplicants"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStageId"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"logoURL"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}}]}}]}}]} as unknown as DocumentNode<OpenCallQuery, OpenCallQueryVariables>;
export const CreateRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddRatingInternalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addRatings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateRatingMutation, CreateRatingMutationVariables>;
export const CandidateRatingAverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CandidateRatingAverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storyRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"submissionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"storyID"}}]}}]}}]} as unknown as DocumentNode<CandidateRatingAverageQuery, CandidateRatingAverageQueryVariables>;
export const GetRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRatings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coralratings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"submissionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"authorID"}},{"kind":"Field","name":{"kind":"Name","value":"storyID"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetRatingsQuery, GetRatingsQueryVariables>;
export const OpenCallStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OpenCallStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"openCallId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"openCallId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"openCallId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"viewPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<OpenCallStagesQuery, OpenCallStagesQueryVariables>;
export const CreateStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"openCallId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"openCallId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"openCallId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"viewPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CreateStageMutation, CreateStageMutationVariables>;
export const RenameStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"openCallId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameStage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"openCallId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"openCallId"}}},{"kind":"Argument","name":{"kind":"Name","value":"stageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"viewPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<RenameStageMutation, RenameStageMutationVariables>;
export const SubmissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Submissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmissionQueryParams"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formDetails"}},{"kind":"Field","name":{"kind":"Name","value":"personalDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experienceBrief"}},{"kind":"Field","name":{"kind":"Name","value":"referredByModelAgency"}},{"kind":"Field","name":{"kind":"Name","value":"agencyName"}},{"kind":"Field","name":{"kind":"Name","value":"instaHandle"}},{"kind":"Field","name":{"kind":"Name","value":"tiktokHandle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personalAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"chest"}},{"kind":"Field","name":{"kind":"Name","value":"waist"}},{"kind":"Field","name":{"kind":"Name","value":"hips"}},{"kind":"Field","name":{"kind":"Name","value":"eyeColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"assetMetaData"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"assetMetaData"}},{"kind":"Field","name":{"kind":"Name","value":"assets"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"openCallId"}},{"kind":"Field","name":{"kind":"Name","value":"stageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"authorID"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"authorID"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}},{"kind":"Field","name":{"kind":"Name","value":"amountOfRatings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRepresented"}},{"kind":"Field","name":{"kind":"Name","value":"nationalities"}},{"kind":"Field","name":{"kind":"Name","value":"cities"}},{"kind":"Field","name":{"kind":"Name","value":"ages"}},{"kind":"Field","name":{"kind":"Name","value":"heights"}},{"kind":"Field","name":{"kind":"Name","value":"eyeColors"}},{"kind":"Field","name":{"kind":"Name","value":"hips"}},{"kind":"Field","name":{"kind":"Name","value":"chests"}},{"kind":"Field","name":{"kind":"Name","value":"waists"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_ids"}}]}}]}}]} as unknown as DocumentNode<SubmissionsQuery, SubmissionsQueryVariables>;
export const BulkChangeStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkChangeStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkChangeStage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"candidateIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<BulkChangeStageMutation, BulkChangeStageMutationVariables>;
export const ContactExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidateId"}},{"kind":"Field","name":{"kind":"Name","value":"averageScore"}},{"kind":"Field","name":{"kind":"Name","value":"stageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}}]}}]}}]} as unknown as DocumentNode<ContactExportQuery, ContactExportQueryVariables>;
export const ExportFinalistsToCopilotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportFinalistsToCopilot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"openCall"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenCallInfoForCopilotExport"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportFinalistsToCopilot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"openCall"},"value":{"kind":"Variable","name":{"kind":"Name","value":"openCall"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualStoryURL"}}]}}]}}]} as unknown as DocumentNode<ExportFinalistsToCopilotQuery, ExportFinalistsToCopilotQueryVariables>;